import { createReducer } from "./functions";

const SET_USERS_SECTORS = "SET_USERS_SECTORS";

const initialState = {
  usersSectorsList: []
};

const usersSectors = {
  [SET_USERS_SECTORS]: (state, action) => {
    const usersSectorsList = action.payload;

    return { ...state, usersSectorsList: [...usersSectorsList] };
  }
};

const usersSectorsReducer = createReducer(initialState, {
  ...usersSectors
});

export default usersSectorsReducer;


// WEBPACK FOOTER //
// src/redux/reducers/usersSectorsReducer.js